// <reference path="components/jq-datagrid/jq-datagrid.component.ts" />
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { jqxTreeModule } from 'jqwidgets-ng/jqxtree'
import { jqxDropDownButtonModule } from 'jqwidgets-ng/jqxdropdownbutton'
import { jqxTreeGridModule } from 'jqwidgets-ng/jqxtreegrid'
import { jqxButtonModule } from 'jqwidgets-ng/jqxbuttons'
import { OrgTreeView } from './components/orgTreeView/orgTreeViewDropdown.Component'
import { OrgHierarchy } from './components/orgHierarchy/orgHierarchy.component'
import { JQTreeGrid } from './components/jq-treegrid/jq-treegrid.component'
import { jqxGridModule } from 'jqwidgets-ng/jqxgrid'
// import { JQGridData } from './components/jq-datagrid/jq-datagrid.component'
import { jqxPanelModule } from 'jqwidgets-ng/jqxpanel'
import { JQTreeMenu } from './components/jq-treemenu/jq-treemenu.component'
import { jqxMenuModule } from 'jqwidgets-ng/jqxmenu'
import { SafeHtmlPipe } from './pipes/safe-html.pipe'
import { jqxDateTimeInputModule } from 'jqwidgets-ng/jqxdatetimeinput'
import { JqDatePicker } from './components/jq-datepicker/datePicker.component'
import { OrgTreeViewMultiSelect } from './components/orgTreeView/org-treeview-multiselect.component'
import { NetworkCommonGateway } from './gateways/network-common-gateway'
import { NetworkStateGateway } from './gateways/network-state-gateway'
import { jqxEditorModule } from 'jqwidgets-ng/jqxeditor'
import { StateListComponent } from './components/state-list/stateList.component'
import { ValidationModule } from '../validations/validation.module'
import { EditFmoAbstractGateway } from '../org-management/gateways/edit-fmo-abstract-gateway'
import { EditFmoGateway } from '../org-management/gateways/edit-fmo-gateway'
import { routes } from './portal-common.routes'
import { RouterModule } from '@angular/router'
import { EPTabsComponent } from './components/tab-control/ep-tabs.component'
import { EPTabComponent } from './components/tab-control/ep-tab.component'
import { CopytoClipboardComponent } from './components/copyto-clipboard/copyto-clipboard.component'
import { ClipboardModule, ClipboardService } from 'ngx-clipboard'
import { FulfillmentGateway } from '../fulfillment/gateways/fulfillment.gateway'
import { NetworkFulfillmentGateway } from '../fulfillment/gateways/network-fulfillment.gateway'
import { OrgListContainerNewComponent } from './components/orgView/org-list-container.component'
import { OrgListNewComponent } from './components/orgView/org-list.component'
import { OrgSearchNewComponent } from './components/orgView/org-search.component'
import { OrgViewComponent } from './components/orgView/org-view.component'

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ValidationModule,
        ClipboardModule,
        jqxTreeGridModule,
        jqxTreeModule,
        jqxDropDownButtonModule,
        jqxPanelModule,
        jqxDateTimeInputModule,
        jqxMenuModule,
        jqxEditorModule,
        jqxGridModule,
        jqxButtonModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        JQTreeGrid,
        OrgTreeView,
        OrgTreeViewMultiSelect,
        OrgHierarchy,
        // JQGridData,
        JQTreeMenu,
        SafeHtmlPipe,
        JqDatePicker,
        StateListComponent,
        EPTabsComponent,
        EPTabComponent,
        CopytoClipboardComponent,
        OrgListContainerNewComponent,
        OrgListNewComponent,
        OrgSearchNewComponent,
        OrgViewComponent
    ],
    exports: [
        JQTreeGrid,
        jqxTreeModule,
        jqxDropDownButtonModule,
        jqxTreeGridModule,
        jqxButtonModule,
        OrgTreeView,
        OrgTreeViewMultiSelect,
        OrgHierarchy,
        jqxGridModule,
        JQTreeMenu,
        jqxPanelModule,
        SafeHtmlPipe,
        jqxDateTimeInputModule,
        JqDatePicker,
        jqxEditorModule,
        EPTabsComponent,
        EPTabComponent,
        jqxMenuModule,
        CopytoClipboardComponent,
        OrgViewComponent
    ],
    providers: [
        NetworkCommonGateway,
        NetworkStateGateway,
        ClipboardService,
        { provide: EditFmoAbstractGateway, useClass: EditFmoGateway },
        { provide: FulfillmentGateway, useClass: NetworkFulfillmentGateway }
    ]
})
export class PortalCommonModule {}
